<template>
  <v-row class="pa-4">
    <p class="checkbox-label" data-qa="enabled-checkbox-label">{{ $t("enabled") }}</p>
      <v-checkbox density="compact" color="primary" false-icon="ecc:ecc-D-QuadOFF" true-icon="ecc:ecc-D-QuadON"
        hide-details v-model="action.enabled" data-qa="enabled-checkbox" />
  </v-row>
  <!-- method -->
  <v-row class="my-0">
    <v-col class="py-1 pr-0">
      <v-select
        v-model="action.webhookConfig.method"
        :label="$t('method')"
        :items="webooktypeItem"
        item-title="name"
        variant="underlined"
        hide-details
      />
    </v-col>
  </v-row>
  <!-- Url -->
  <v-row class="my-0">
    <v-col class="py-1 pr-0">
      <v-text-field
        required
        data-qa="trigger-action-webhookConfig-uri"
        v-model="action.webhookConfig.url"
        :label="$t('url')"
        :rules="URIRules"
        :disabled="isUpdating"
        hide-details
      />
    </v-col>
  </v-row>
  <!-- headers -->
  <v-row class="my-0">
    <v-col class="py-3 pr-0">
      <v-card variant="flat" density="compact">
        <v-card-title class="pa-0" style="font-size: 12px; font-weight: 400">
          {{ $t("headers") }}:
        </v-card-title>
        <v-card-text class="py-0">
          <div class="checkbox-div">
            <v-row class="my-0">
              <v-col class="py-0">
                <v-text-field
                  class=""
                  data-qa="notification-extra-search"
                  v-model="headerKey"
                  type="text"
                  :placeholder="$t('key')"
                  @click:append-outer="validateChip"
                />
              </v-col>
              <v-col class="py-0">
                <v-text-field
                  class="pl-4"
                  data-qa="notification-extra-search"
                  v-model="headerValue"
                  type="text"
                  :placeholder="$t('value')"
                  @keyup.enter="validateChip"
                  append-outer-icon="ecc:ecc-TB-Enter"
                  @click:append-outer="validateChip"
                  :iconDisabled="!canEnterExtraFilters"
                />
              </v-col>
            </v-row>
            <v-row v-if="currentHeaders.length" class="my-1 mx-2">
              <v-chip
                class="ecc max-100 mr-1 mb-1"
                v-for="item in currentHeaders"
                v-bind:key="item.key + '-' + item.value"
              >
                <p class="ellipsis-text">{{ item.key }} : {{ item.value }}</p>
                <v-btn
                  data-qa="remove-chip-button"
                  text
                  icon
                  class="close"
                  @click="removeHeader(item)"
                >
                  ✕
                </v-btn>
              </v-chip>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
  <!-- body  -->
  <v-row class="my-0">
    <v-col class="py-1 pr-0">
      <div>Body</div>
      <MustacheEditor
        owner="template-mustache"
        v-model="action.webhookConfig.template"
        @update:value="updateValue"
        :width="440"
        :height="250"
        dataQa="template-mustache"
        refName="template"
      ></MustacheEditor>
    </v-col>
  </v-row>
  <!-- x-days -->
  <TriggerActionXdaysComponent class="pa-0" :config="action.webhookConfig" />
</template>

<script lang="ts">
import MustacheEditor from '../UIComponents/MustacheEditor.vue';
import { defineComponent } from "vue";
import {
  TriggerWebhookAction,
  TriggerActionWebhookTypeEnum,
} from "./type.util";
import AnimatedButton from "../UIComponents/AnimatedButton.vue";
import TriggerActionXdaysComponent from './TriggerActionXdaysComponent.vue';

export default defineComponent({
  name: "TriggerActionWebhookComponent",
  components: {
    AnimatedButton,
    MustacheEditor,
    TriggerActionXdaysComponent,
  },
  data() {
    return {
      isUpdating: false,
      URIRules: [
        (v) => /\w+:(\/?\/?)[^\s]+/i.test(v) || this.$t("notValidURI"),
      ],
      webooktypeItem: Object.values(TriggerActionWebhookTypeEnum),
      headerKey: null,
      headerValue: null,
      currentHeaders: [],
    };
  },
  props: {
    action: {
      type: Object as () => TriggerWebhookAction,
      default: null,
    },
  },
  computed: {
    canEnterExtraFilters: function (): string {
      return this.headerKey && this.headerValue;
    },
  },
  methods: {
    removeHeader(event) {
      this.currentHeaders.splice(this.currentHeaders.indexOf(event), 1);
      delete this.action.webhookConfig.headers[event.key];
    },
    deleteActionConfirmation(): void {
      this.$emit("deleteActionConfirmation", this.action);
    },
    validateChip(event): void {
      if (!this.headerKey || !this.headerValue) {
        return;
      }
      const newHeader = {
        key: this.headerKey,
        value: this.headerValue,
      };
      if (this.currentHeaders.find((o) => o.key == newHeader.key)) {
        return;
      }
      this.currentHeaders.push(newHeader);

      this.action.webhookConfig.headers[newHeader.key] = newHeader.value;
      this.headerKey = "";
      this.headerValue = "";
    },
    importHeader() {
      this.currentHeaders = [];
      for (let key in this.action.webhookConfig.headers) {
        const newHeader = {
          key: key,
          value: this.action.webhookConfig.headers[key],
        };
        this.currentHeaders.push(newHeader);
      }
    },
    updateValue(value){
      this.action.webhookConfig.template = value;
    },
  },
  watch: {
    action: function (action): void {
      this.importHeader();
    },
  },
  mounted() {
    this.importHeader();
  },
});
</script>

<style scoped>
.header {
  font-weight: bold;
}
.checkbox-list {
  width: 100%;
}
.checkbox-label {
  line-height: 40px;
  width: 60px;
}
.email-text-area.v-textarea >>> textarea {
  border: 1px solid var(--color-g4);
  padding: 20px 8px 2px 8px;
  margin-top: 10px;
  line-height: 1.1rem;
}
.policy-header {
  color: var(--color-g4);
}
.max-100 {
  max-width: 100%;
}
.ellipsis-text {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
}
.ecc.v-chip .close {
  color: var(--color-dk) !important;
}
</style>


